import { render, staticRenderFns } from "./PrivateRatesTable.vue?vue&type=template&id=c186bc92&scoped=true&"
import script from "./PrivateRatesTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PrivateRatesTable.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c186bc92",
  null
  
)

export default component.exports